<template>
	<v-container fluid grid-list-md class="pa-0 ma-0">
		<v-layout row wrap>
			<v-flex xs12 class="py-0">
				<v-parallax dark :src="outlet.image_url" height="300">
					<v-overlay absolute color="secondary">
						<v-row align="center" justify="center">
							<v-col class="text-center" cols="12">
								<h1 class="text-h3 font-weight-thin mb-4">
									{{ outlet.name }}
								</h1>
								<h4
									class="subheading font-weight-normal"
									style="max-width: 800px; margin: auto"
									v-html="outlet.description"
								></h4>
							</v-col>
						</v-row>
					</v-overlay>
				</v-parallax>
			</v-flex>
			<v-flex xs12 class="pt-0">
				<v-tabs
					background-color="secondary"
					dark
					next-icon="mdi-arrow-right-bold-box-outline"
					prev-icon="mdi-arrow-left-bold-box-outline"
					show-arrows
					center-active
					v-model="category"
				>
					<Link
						as="v-tab"
						text
						dark
						:href="
							$route('shop.delivery.products', {
								tenant: $page.props.tenant.id,
								outlet: outlet.uuid,
							})
						"
						:input-value="!category_id"
						:only="['products', 'category_id']"
					>
						<v-icon left size="24">mdi-shape</v-icon>
						{{ $t("label.all_categories") }}
					</Link>
					<Link
						v-for="(category, index) in categories"
						:key="index"
						as="v-tab"
						:href="
							$route('shop.delivery.products', {
								tenant: $page.props.tenant.id,
								outlet: outlet.uuid,
								category_id: category.id,
							})
						"
						text
						dark
						:input-value="category_id == category.id"
						:only="['products', 'category_id']"
					>
						<v-img
							height="30"
							width="30"
							:src="category.image_url"
							contain
							class="mr-2"
						></v-img>
						{{ category.name }}
					</Link>
				</v-tabs>
			</v-flex>
			<v-flex xs12>
				<v-container grid-list-md class="container--box">
					<v-layout row wrap>
						<v-flex xs12>
							<OutletClosedAlert
								v-model="outlet.is_openning"
							></OutletClosedAlert>
						</v-flex>
						<v-flex xs12 md12>
							<h2 class="font-weight-bold white--text">
								{{ $t("label.products") }}
							</h2>
						</v-flex>
						<v-flex xs12 md12>
							<ShopProductGrid
								:products="products"
								@succeed="$refs.cart_drawer.getCart()"
								:type="'pickup'"
							></ShopProductGrid>
						</v-flex>
					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>
		<ShopCartDrawer
			ref="cart_drawer"
			:outlet_uuid="outlet.uuid"
			:type="'pickup'"
		></ShopCartDrawer>
	</v-container>
</template>

<script>
import ShopProductGrid from "@Shop/components/ShopProductGrid.vue";
import ShopCategoryGrid from "@Shop/components/ShopCategoryGrid.vue";
import ShopCartDrawer from "@Shop/components/ShopCartDrawer.vue";
import OutletClosedAlert from "@Shop/components/OutletClosedAlert.vue";
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
		ShopCategoryGrid,
		ShopProductGrid,
		ShopCartDrawer,
		OutletClosedAlert,
	},

	props: ["outlet", "categories", "products", "category_id"],

	data() {
		return {
			category:
				this.categories.findIndex(
					(category) => category.id == this.category_id
				) + 1,
		};
	},
};
</script>